import { render } from "./Loader.vue?vue&type=template&id=331e6c24&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=331e6c24&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-331e6c24"

export default script